document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".price-item").forEach(function (el) {
    el.textContent = el.textContent
      .replace(/\sEGP/g, "")
      .replace(/\.00/g, "")
      .trim();
  });
});
/* RE3AYA PRODUCT SHARE BUTTON */

document.addEventListener("DOMContentLoaded", function () {

  const media = document.querySelector(".product__media-wrapper");

  if (!media) return;
  if (document.querySelector(".r3-share-btn")) return;

  const btn = document.createElement("button");

  btn.className = "r3-share-btn";
  btn.type = "button";

  btn.innerHTML = `
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="18" cy="5" r="3"></circle>
    <circle cx="6" cy="12" r="3"></circle>
    <circle cx="18" cy="19" r="3"></circle>
    <path d="M8.6 10.7L15.4 6.3"></path>
    <path d="M8.6 13.3L15.4 17.7"></path>
  </svg>
  `;

  btn.addEventListener("click", function () {

    if (navigator.share) {

      navigator.share({
        title: document.title,
        url: window.location.href
      });

    } else {

      navigator.clipboard.writeText(window.location.href);
      alert("Link copied");

    }
  });

  media.appendChild(btn);

});
/* RE3AYA SIMPLE CLICKABLE BRAND */

document.addEventListener("DOMContentLoaded", function () {
  var vendor = document.querySelector(".product__info-container .product__text.caption-with-letter-spacing");

  if (!vendor) return;

  var vendorName = vendor.textContent.trim();

  if (!vendorName) return;

  vendor.classList.add("r3-brand-ready");

  vendor.innerHTML =
    '<span class="r3-brand-label">Brand: </span>' +
    '<span class="r3-brand-name">' + vendorName + '</span>';

  vendor.onclick = function () {
    window.location.href =
      "/collections/vendors?q=" + encodeURIComponent(vendorName);
  };
});
